export default "__VITE_ASSET__CenqASPI__"